export default "__VITE_ASSET__Ch8g2M5i__"